$(function() {
    $('.modal__close, .modal__bg').on('click', function(){
        Manogi.closeModal();
    });

    $('.modal').on('click', '*[data-action="close-modal"]', function(){
        Manogi.closeModal();
    });
});
